<template>
  <div class="flex flex-col items-center justify-center min-h-screen bg-gray-100">
    <div class="text-center">
      <h1 class="text-6xl font-bold text-gray-800 mb-4">404</h1>
      <p class="text-2xl text-gray-600 mb-8">Oops! This bubble doesn't exist.</p>
      <div class="relative w-64 h-64 mb-8 mx-auto">
        <div class="absolute inset-0 bg-blue-500 rounded-full opacity-20 animate-ping" />
        <div class="absolute inset-4 bg-blue-400 rounded-full opacity-40 animate-pulse" />
        <div class="absolute inset-8 bg-blue-300 rounded-full opacity-60 animate-bounce" />
        <div class="absolute inset-12 bg-blue-200 rounded-full opacity-80" />
      </div>
      <button
        class="px-6 py-3 bg-black text-white rounded-full hover:bg-gray-800 transition duration-300 ease-in-out"
        @click="handleClick"
      >
        Back to Home
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useLogger } from '~/composables/useLogger'

const logger = useLogger()
const router = useRouter()

const handleClick = async () => {
  logger.debug('[DoesNotExist] Click handler triggered')
  try {
    logger.debug('[DoesNotExist] Attempting navigation to /dashboard/home')
    await navigateTo('/dashboard/home', { replace: true })
    logger.log('[DoesNotExist] Navigation successful')
  } catch (error) {
    logger.logError('[DoesNotExist] Navigation failed:', error)
    // Fallback to router.push if navigateTo fails
    try {
      logger.debug('[DoesNotExist] Attempting fallback with router.push')
      await router.push('/dashboard/home')
      logger.log('[DoesNotExist] Fallback navigation successful')
    } catch (routerError) {
      logger.logError('[DoesNotExist] Fallback navigation failed:', routerError)
      // Last resort: window.location
      logger.debug('[DoesNotExist] Using window.location as last resort')
      window.location.href = '/dashboard/home'
    }
  }
}
</script>

<style scoped>
@keyframes ping {
  75%,
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }

  50% {
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}

.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.animate-bounce {
  animation: bounce 1s infinite;
}
</style>
